import { DeeplinkRequestApiDto, DeeplinkResponseApiDto } from '@lx/shared/api';

export type DeeplinkRequest = DeeplinkRequestApiDto;
export type PreselectedMode = DeeplinkRequestApiDto.PreselectedModeEnum;
export const PreselectedModeEnum = DeeplinkRequestApiDto.PreselectedModeEnum;
export type DeeplinkResponse = DeeplinkResponseApiDto;
export const DeeplinkTypeEnum = DeeplinkRequestApiDto.DeeplinkTypeEnum;
